module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "admin-sidebar",
    attrs: {
      "id": "page-content"
    }
  }, [_c('div', {
    staticClass: "component-padding"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "products-list"
  }, _vm._l((9), function(n) {
    return _c('div', {
      staticClass: "col-md-4 product-item-admin"
    }, [_c('img', {
      attrs: {
        "src": "static/images/j.jpeg"
      }
    }), _vm._v(" "), _vm._m(1, true), _vm._v(" "), _vm._m(2, true), _vm._v(" "), _vm._m(3, true), _vm._v(" "), _vm._m(4, true)])
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "products-admin-options"
    }
  }, [_c('h1', [_vm._v("Purchase Products")]), _vm._v(" "), _c('div', [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Search Product"
    }
  }), _vm._v(" "), _c('select', {
    attrs: {
      "name": "francis"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("All Products")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Wall Sconces")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Chandeliers")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Pendants")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Undercabinet")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Ceiling")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Desk, Floor & Table Lamps")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Track")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Architectural")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Recessed")])]), _vm._v(" "), _c('select', {
    attrs: {
      "name": "fabrianne"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("All Suppliers")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Phelix Systems")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Fabrianne Inc")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Ast Corps")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Supplier: "), _c('strong', [_vm._v("Phelix Systems")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Product Code: "), _c('strong', [_vm._v("6SGHA14")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Price: "), _c('strong', [_vm._v("Php 140.00")]), _vm._v(" "), _c('small', [_vm._v("FOB")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "admin-purchase-options"
  }, [_c('button', {
    staticClass: "col-md-6"
  }, [_vm._v("View Product")]), _vm._v(" "), _c('button', {
    staticClass: "col-md-6"
  }, [_vm._v("Add to Cart")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e15d6ea0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AdminPurchase.vue
// module id = 165
// module chunks = 0